import React from 'react';
import { TriangleAlert } from 'lucide-react';
import { cx } from './classNames';
import './ui.css';

export type BadgeTone = 'ok' | 'warn' | 'danger' | 'info' | 'muted' | 'primary';

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
  /** 先頭アイコン。warn は未指定でも AlertTriangle が付く（色以外の手掛かりを持たせる） */
  icon?: React.ReactNode;
}

export function Badge({ tone = 'muted', icon, className, children, ...rest }: BadgeProps) {
  const leading =
    icon ?? (tone === 'warn' ? <TriangleAlert aria-hidden="true" data-testid="ui-badge-warn-icon" /> : null);

  return (
    <span className={cx('ui-badge', `ui-badge--${tone}`, className)} {...rest}>
      {leading}
      {children}
    </span>
  );
}
